/**
 * Profile card click handler - Makes cards clickable while preserving interactive elements
 */
(function() {
    'use strict';

    // Validate URL to prevent XSS
    function isValidProfileUrl(url) {
        if (!url || typeof url !== 'string') return false;
        // Must start with / and not contain protocol handlers
        return url.startsWith('/') && !url.match(/^(javascript|data|vbscript|file):/i);
    }

    // Apply styles to profile cards
    function styleProfileCard(card) {
        if (card.dataset.profileUrl && isValidProfileUrl(card.dataset.profileUrl)) {
            card.style.cursor = 'pointer';
        }
    }

    // Close all profile card dropdown menus
    function closeAllDropdowns(exceptMenu) {
        document.querySelectorAll('[data-profile-card] .relative > div.hidden + div, [data-profile-card] .relative > button + div:not(.hidden)').forEach(function(menu) {
            if (menu !== exceptMenu && !menu.classList.contains('hidden')) {
                menu.classList.add('hidden');
            }
        });
    }

    // Process newly added nodes for profile cards
    function processAddedNodes(nodes) {
        nodes.forEach(node => {
            if (!node.querySelectorAll) return;

            // Check if the node itself is a profile card
            if (node.matches && node.matches('[data-profile-card]')) {
                styleProfileCard(node);
            }

            // Check for profile cards within the node
            const cards = node.querySelectorAll('[data-profile-card]');
            cards.forEach(styleProfileCard);
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        // Close dropdown menus when clicking outside
        document.addEventListener('click', function(e) {
            // Check if click is inside a dropdown menu or its toggle button
            const dropdownMenu = e.target.closest('[data-profile-card] .relative > div.absolute');
            const dropdownToggle = e.target.closest('[data-profile-card] .relative > button');

            if (!dropdownMenu && !dropdownToggle) {
                // Click was outside all dropdown menus and toggles - close all
                closeAllDropdowns();
            }
        });

        // Event delegation for clicks
        document.body.addEventListener('click', function(e) {
            const card = e.target.closest('[data-profile-card]');
            if (!card) return;

            const profileUrl = card.dataset.profileUrl;
            if (!isValidProfileUrl(profileUrl)) return;

            // Skip if clicking interactive elements
            if (e.target.closest('a, button, input, select, textarea, [role="button"]')) return;

            // Skip if text is selected
            if (window.getSelection().toString()) return;

            // Navigate safely
            try {
                window.location.href = profileUrl;
            } catch (err) {
                console.error('Failed to navigate to profile:', err);
            }
        });
        
        // Style existing cards
        document.querySelectorAll('[data-profile-card]').forEach(styleProfileCard);
        
        // Observe for dynamically added cards - optimized to only check specific containers
        const observer = new MutationObserver(function(mutations) {
            const addedNodes = [];
            mutations.forEach(mutation => {
                if (mutation.addedNodes.length) {
                    addedNodes.push(...mutation.addedNodes);
                }
            });
            
            if (addedNodes.length) {
                // Debounce with requestAnimationFrame
                requestAnimationFrame(() => processAddedNodes(addedNodes));
            }
        });
        
        // Only observe containers likely to have dynamic content
        const containers = [
            document.getElementById('quick-search__results'),
            document.getElementById('aFeed'),
            document.querySelector('.main-content-col')
        ].filter(Boolean);
        
        containers.forEach(container => {
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        });
        
        // Cleanup on page unload (for SPAs)
        window.addEventListener('beforeunload', () => observer.disconnect());
    });
})();